export { AmbientVideoMarquee as default } from "./ambient-video-marquee";
export type { AmbientVideoMarqueeProps } from "./ambient-video-marquee";
